//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RichCourseItem from "../components/rich/CourseItem.vue";
import RecommendTeacher from "../components/recommend/RecommendTeacher.vue";
import RecommendCoupon from "../components/recommend/RecommendCoupon.vue";
import GoodsItem from "@/components/GoodsItem.vue";
import RichPublicItem from "../components/rich/PublicCourseItem.vue";
import NewsHome from "../components/rich/NewsHome.vue";
import PeriodsItem from "../components/periods/PeriodsItem.vue";
import PackageItem from "../components/package/PackageItem.vue";
import ClassesItem from "../components/classes/ClassesItem.vue";
import EbooksItem from "@/components/EbooksItem.vue";
export default {
  name: "Index",
  components: {
    GoodsItem: GoodsItem,
    RichCourseItem: RichCourseItem,
    RichPublicItem: RichPublicItem,
    NewsHome: NewsHome,
    RecommendTeacher: RecommendTeacher,
    RecommendCoupon: RecommendCoupon,
    PeriodsItem: PeriodsItem,
    PackageItem: PackageItem,
    ClassesItem: ClassesItem,
    EbooksItem: EbooksItem
  },
  data: function data() {
    return {
      openCourses: [],
      openCourseItmes: [],
      openCoursePage: 1,
      currentTeacherIndex: 0
    };
  },
  computed: {
    // banner参数
    swiperOption: function swiperOption() {
      return {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: this.bannerList.length > 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };
    },
    currentTeacher: function currentTeacher() {
      var recommend = this.recommendList.filter(function (r) {
        return r.channel_info.type == 3;
      })[0];

      if (!recommend) {
        return;
      }

      return recommend.list[this.currentTeacherIndex];
    },
    bannerList: function bannerList() {
      return this.$store.state.indexData.bannerList;
    },
    recommendList: function recommendList() {
      return this.$store.state.indexData.recommendList;
    }
  },
  methods: {
    onSlideChange: function onSlideChange() {
      var index = this.$refs.mySwiper.swiper.realIndex;
      this.$refs.bagcodeRef.style.background = this.bannerList.length > 0 && this.bannerList[index].bagcode_color;
    },
    getScrollWidth: function getScrollWidth() {
      var noScroll,
          scroll,
          oDiv = document.createElement("DIV");
      oDiv.style.cssText = "position:absolute; top:-1000px; width:100px; height:100px;";
      noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = "scroll";
      scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      return noScroll - scroll;
    }
  },
  mounted: function mounted() {
    // this.$kefu()
    this.$nextTick(function () {// let scrollWidth = this.getScrollWidth();
      // let scrollWidth = window.outerWidth;
      // this.$refs.banner.style.height ="calc((100vw - " + scrollWidth + "px) * 460 / 1920";
      // this.$refs.banner.style.height = 340 + "px";
    });
  }
};